import { CommonModule } from '@angular/common';
import { Component, computed, ElementRef, input, output, signal, ViewChild } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { UserAvatarFileDto } from '@workspace/data-types';
import { fileSizeDisplayTransform } from '../../../pipes/enum-display/file-size-display.pipe';
import { FileInputPreviewAuraComponent } from './preview/file-input-preview.component';

@Component({
  selector: 'aura-file-input',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatIconModule,
    MatButtonModule,
    FileInputPreviewAuraComponent,
  ],
  templateUrl: './file-input.component.html',
})
export class AvatarFileInputAuraComponent {
  control = input.required<FormControl<UserAvatarFileDto | File | null>>();
  label = input<string | null>();
  placeholder = input.required<string>();
  maxFileSize = input<number>(2 * 1024 * 1024); // 2MB default
  fileSelected = output<File | null>();
  fileName = signal<string | null>(null);
  fileAccept = input.required<string>();

  @ViewChild('fileInput') fileInputEl?: ElementRef<HTMLInputElement>;

  maxFileSizeLabel = computed(() => {
    const size = this.maxFileSize();
    return fileSizeDisplayTransform(size);
  });

  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0] ?? null;

    if (!file) return;

    this.control().setErrors(null);

    if (file.size > this.maxFileSize()) {
      this.control().setErrors({ fileTooLarge: true });
      input.value = ''; // reset the input
      return;
    }

    this.fileName.set(file.name);
    this.control().setValue(file);
    this.fileSelected.emit(file);
  }

  removeFile() {
    this.fileName.set(null);
    this.control().setValue(null);
    this.fileSelected.emit(null);

    // Reset the native file input so the same file can be selected again
    if (this.fileInputEl) {
      this.fileInputEl.nativeElement.value = '';
    }
  }
}
